if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // The first span in the button is the cart icon, not the label, so
        // querySelector('span') wrote every sold-out / variant text swap into
        // the icon. Prefer the labelled span; fall back to the first span that
        // is neither the icon nor the spinner.
        this.submitButtonText =
          this.submitButton.querySelector('.ct-button-text') ||
          Array.from(this.submitButton.querySelectorAll('span')).find(
            (span) => !span.closest('.ct-cart-icon') && !span.closest('.loading__spinner')
          );

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.setLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            /* The button keeps spinning until the cart drawer is actually on
               screen. Clearing it here, the moment the request resolves, left
               a gap where the button looked idle and nothing had visibly
               happened yet - which is what made people press it twice. */
            this.whenCartVisible().then(() => this.setLoading(false));
          });
      }

      /* Not every button that this element wraps ships a spinner, and
         calling .classList on a missing one threw inside the submit handler -
         after preventDefault, so the add never fired at all and the page just
         did nothing. Missing spinner now means no spinner, not a dead button. */
      setLoading(on) {
        this.submitButton.classList.toggle('loading', on);
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !on);
      }

      /* Resolves once the drawer has opened, or immediately when there is no
         drawer to wait for. Capped, so a drawer that never opens - an error,
         a theme without one - can never leave a button spinning forever. */
      whenCartVisible() {
        const cart = this.cart;
        const isOpen = () =>
          cart && (cart.classList.contains('active') || cart.classList.contains('animate') ||
                   cart.getAttribute('aria-hidden') === 'false' || cart.hasAttribute('open'));
        if (!cart || this.error || isOpen()) return Promise.resolve();
        return new Promise((resolve) => {
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            observer.disconnect();
            clearTimeout(timer);
            resolve();
          };
          const observer = new MutationObserver(() => { if (isOpen()) finish(); });
          observer.observe(cart, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
          const timer = setTimeout(finish, 3000);
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
